import { render, staticRenderFns } from "./CheckBoxDisplay.vue?vue&type=template&id=73e36e62&scoped=true&"
import script from "./CheckBoxDisplay.vue?vue&type=script&lang=js&"
export * from "./CheckBoxDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e36e62",
  null
  
)

export default component.exports